const init = () => {
  const bodyElement = document.querySelector('body');
  const htmlElement = document.querySelector('html');

  return {
    bodyElement,
    htmlElement,
  };
};

const lockBodyElement = () => {
  const { bodyElement, htmlElement } = init();
  if (!bodyElement || !htmlElement) return;
  bodyElement?.classList.add('overflow-hidden', 'relative', 'h-full');
  htmlElement?.classList.add('overflow-hidden', 'relative', 'h-full');
};

const clearAllBodyElementLocks = () => {
  const { bodyElement, htmlElement } = init();

  if (!bodyElement || !htmlElement) return;
  bodyElement?.classList.remove('overflow-hidden', 'relative', 'h-full');
  htmlElement?.classList.remove('overflow-hidden', 'relative', 'h-full');
};

export const WindowScrollService = {
  lockBodyElement,
  clearAllBodyElementLocks,
};
